'use strict';

const processInclude = require('base/util');

$(window).on('load', function () {
    processInclude(require('./jNext/jNext'));
});

